import { NotePopupProps } from '@lmt/unicorn-shared/app/components/calendar/devextreme/resource-view/ResourceViewScheduler';
import { NotePopup } from '@lmt/unicorn-shared/app/components/calendar/notes/popup/NotePopup';
import { AppPopper } from '@lmt/unicorn-shared/app/components/common/ui-kit/tooltip/AppPopper';
import clsx from 'clsx';
import { format, isSameDay, startOfDay } from 'date-fns';
import { bindHover, bindPopper } from 'material-ui-popup-state';
import { usePopupState } from 'material-ui-popup-state/hooks';
import React, { FC, useState } from 'react';
import { NoteDto } from '@lmt/shared-types';
import { HolidaysAndAnonimized } from '@lmt/unicorn-shared/app/components/calendar/devextreme/common';
import { localFormat } from '@lmt/unicorn-shared/app/helpers/date-helper';
import styles from './DayViewCalendarHeader.module.scss';
import calendarStyles from './Calendar.module.scss';
import HolidayIcon from '@lmt/unicorn-shared/app/icons/holiday.svg?react';
import { NoteIconComponent } from '../resource-view/NoteIconComponent';

interface Props {
  currentDate: Date;
  holidays: Record<string, HolidaysAndAnonimized[]>;
  notes: Record<string, NoteDto[]>;
}

export const DayViewCalendarHeader: FC<Props> = (props) => {
  const { currentDate } = props;

  const holidays = props.holidays[format(currentDate, 'yyyy-MM-dd')] ?? [];
  const notes = props.notes[format(currentDate, 'yyyy-MM-dd')] ?? [];

  const [popupNotes, setPopupNotes] = useState<NotePopupProps | undefined>(
    undefined,
  );
  const popupState = usePopupState({
    variant: 'popper',
    popupId: 'calendar-note',
  });
  const bindHoverRef = bindHover(popupState);

  return (
    <div
      className={clsx(
        styles.dayCalendarHeader,
        isSameDay(currentDate, startOfDay(new Date())) &&
          (holidays.length > 0
            ? styles.dayCalendarHeaderTodayHoliday
            : styles.dayCalendarHeaderToday),
      )}
    >
      <div className={styles.dayCalendarHeaderDate}>
        {localFormat(currentDate, 'EEE d')}
      </div>
      {holidays.length > 0 && (
        <div
          className={clsx(
            styles.dayCalendarHeaderItem,
            styles.dayCalendarHeaderHoliday,
          )}
        >
          <HolidayIcon className={calendarStyles.holidayIcon} />
          <span>{holidays[0].title}</span>
        </div>
      )}
      {notes.length > 0 && (
        <div
          className={clsx(
            styles.dayCalendarHeaderItem,
            styles.dayCalendarHeaderNote,
          )}
          onMouseOver={(e) => {
            setPopupNotes({
              date: currentDate,
              notes,
            });
            bindHoverRef.onMouseOver(e);
          }}
          onMouseLeave={(e) => {
            bindHoverRef.onMouseLeave(e);
          }}
          data-test-id="date-cell-note-container"
        >
          <NoteIconComponent notes={notes} />
          <div className={styles.noteTextContainer}>{notes[0].text}</div>
        </div>
      )}
      {popupNotes && (
        <AppPopper {...bindPopper(popupState)} delay={500}>
          <NotePopup notes={popupNotes.notes} handleClose={popupState.close} />
        </AppPopper>
      )}
    </div>
  );
};
